import { useContext, useEffect, useState } from 'react'
import { Select, TextField } from '@nv/basic-components'
import { ModalContext } from '@nv/contexts'
import { AdminVoterService } from '@nv/services'
import { useFormik } from 'formik'
import i18next from 'i18next'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

export const DeclineVoterForm = ({ confirm, maxChars = 500 }: any) => {
  const { t } = useTranslation()
  const currentLanguage = i18next.language
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)
  const [declineOptions, setDeclineOptions] = useState([])

  const formik = useFormik({
    initialValues: { reason: '', reasonText: { en: '', fr: '' } },
    validationSchema: Yup.object({
      reason: Yup.string().required(t('admin.electorsList.validations.reasonRequired')),
      reasonText: Yup.string().when('reason', {
        is: (arg) => arg === 'OTHER',
        then: () =>
          Yup.object().shape({
            en: Yup.string().required(t('admin.electorsList.validations.reasonRequired')),
            fr: Yup.string(),
          }),
        otherwise: () => Yup.object(),
      }),
    }),
    onSubmit: (values) => {
      confirm(values)
    },
  })

  useEffect(() => {
    const getDeclineReasonOptions = async () => {
      const options = await AdminVoterService.getDeclineOptions(currentLanguage)

      if (options) {
        setDeclineOptions(options)
      }
    }
    getDeclineReasonOptions()
  }, [])

  useEffect(() => {
    setHeaderLabel(t('admin.onlineRegistration.declineVoter'))
    setBtns([
      { text: t('buttons.cancel'), variant: 'secondary', onClick: onClose, isCancel: true },
      { text: t('buttons.decline'), onClick: formik.handleSubmit },
    ])
  }, [])

  return (
    <div style={{ minHeight: 300 }}>
      <Select
        label={t('admin.onlineRegistration.selectReasonToDecline')}
        formik={formik}
        options={declineOptions}
        field='reason'
        value={formik.values.reason}
        isRequired={true}
        ariaLabel={t('admin.onlineRegistration.selectReasonToDecline')}
      />
      <br />
      {formik.values.reason === 'OTHER' && (
        <>
          <TextField
            formik={formik}
            field={'reasonText.en'}
            label={t('admin.onlineRegistration.enterReasonEn')}
            ariaLabel={t('admin.onlineRegistration.enterReasonEn')}
            placeholder={t('admin.onlineRegistration.enterReason')}
            maxChars={maxChars}
            maxLength={maxChars}
            isRequired={true}
          />
          <br />
          <TextField
            formik={formik}
            field='reasonText.fr'
            label={t('admin.onlineRegistration.enterReasonFr')}
            ariaLabel={t('admin.onlineRegistration.enterReasonFr')}
            placeholder={t('admin.onlineRegistration.enterReason')}
            maxChars={maxChars}
            maxLength={maxChars}
            isRequired={false}
          />
        </>
      )}
    </div>
  )
}
